"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterLink = void 0;
var React = __importStar(require("react"));
var Text_1 = require("../../Text/Text");
var styled_components_1 = __importDefault(require("styled-components"));
var Color_1 = __importDefault(require("../../Variables/Color"));
var MenuItemsStyles = styled_components_1.default.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  list-style: none;\n  padding: 0;\n"], ["\n  list-style: none;\n  padding: 0;\n"])));
exports.FooterLink = styled_components_1.default.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n    color: ", ";\n  }\n\n  line-height: 30px;\n"], ["\n  color: ", ";\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n    color: ", ";\n  }\n\n  line-height: 30px;\n"])), Color_1.default.BRAND_WHITE, Color_1.default.BRAND_WHITE);
var FooterMenuList = function (_a) {
    var listItems = _a.listItems, onLinkClick = _a.onLinkClick;
    return (React.createElement(MenuItemsStyles, null, listItems &&
        listItems.map(function (item) {
            var _a;
            return (React.createElement("li", { key: item.text },
                React.createElement(exports.FooterLink, { href: (_a = item.url) !== null && _a !== void 0 ? _a : '#', onClick: function (e) {
                        e.preventDefault();
                        item.onClickHandler ? item.onClickHandler(item) : onLinkClick(item);
                    } },
                    React.createElement(Text_1.Text, { xl: true }, item.text))));
        })));
};
exports.default = FooterMenuList;
var templateObject_1, templateObject_2;
